import { Route, Switch, useRouteMatch } from "react-router-dom";

import { AddLicenseFormProvider } from "../../Roles/AddLicense/FormProvider";
import { AddLicenseModalRoutes } from "../../Roles/AddLicense/ModalRoutes";
import { AddLicensePage } from "../../Roles/AddLicense/Page";
import { ADD_LICENSE_PATH } from "../../Roles/AddLicense/paths";
import { RoleModalRoutes } from "../../Roles/ModalRoutes";
import { ROLE_REMOVED_MODAL_PATH } from "../../Roles/paths";
import { AccountAddRolesPage } from "./AddRoles/Page";
import { AccountRolesPage } from "./Page";
import {
  ACCOUNT_ADD_ROLES_PATH,
  ACCOUNT_ROLE_DETAILS_ADD_LICENSE_ADD_QUALIFICATION_MODAL_FULL_PATH,
  ACCOUNT_ROLE_DETAILS_ADD_LICENSE_ADD_STATE_MODAL_FULL_PATH,
  ACCOUNT_ROLE_DETAILS_ADD_LICENSE_DUPLICATE_MODAL_FULL_PATH,
  ACCOUNT_ROLE_DETAILS_ADD_LICENSE_ERROR_MODAL_FULL_PATH,
  ACCOUNT_ROLE_DETAILS_ADD_LICENSE_FULL_PATH,
  ACCOUNT_ROLE_DETAILS_ADD_LICENSE_IN_REVIEW_MODAL_FULL_PATH,
  ACCOUNT_ROLE_DETAILS_ADD_LICENSE_SUBMITTING_MODAL_FULL_PATH,
  ACCOUNT_ROLE_DETAILS_FULL_PATH,
  ACCOUNT_ROLE_DETAILS_PATH,
  ACCOUNT_ROLES_FULL_PATH,
} from "./paths";
import { AccountRoleDetailsPage } from "./RoleDetails/Page";

export function AccountRolesRouter() {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route exact path={[`${match.url}`, `${match.url}/${ROLE_REMOVED_MODAL_PATH}`]}>
        <AccountRolesPage />
        <RoleModalRoutes basePath={`${match.url}`} rolesPath={ACCOUNT_ROLES_FULL_PATH} />
      </Route>

      <Route path={`${match.url}/${ACCOUNT_ADD_ROLES_PATH}`}>
        <AccountAddRolesPage />
      </Route>

      <Route
        path={`${match.url}/${ACCOUNT_ROLE_DETAILS_PATH}`}
        render={({ match: routeMatch }) => {
          const { qualificationId } = routeMatch.params;

          const paths = {
            rolePath: ACCOUNT_ROLES_FULL_PATH,
            roleDetailsPath: ACCOUNT_ROLE_DETAILS_FULL_PATH,
            inReviewPath: ACCOUNT_ROLE_DETAILS_ADD_LICENSE_IN_REVIEW_MODAL_FULL_PATH,
            duplicatePath: ACCOUNT_ROLE_DETAILS_ADD_LICENSE_DUPLICATE_MODAL_FULL_PATH,
            errorPath: ACCOUNT_ROLE_DETAILS_ADD_LICENSE_ERROR_MODAL_FULL_PATH,
            addQualificationPath:
              ACCOUNT_ROLE_DETAILS_ADD_LICENSE_ADD_QUALIFICATION_MODAL_FULL_PATH,
            submittingPath: ACCOUNT_ROLE_DETAILS_ADD_LICENSE_SUBMITTING_MODAL_FULL_PATH,
            addStatePath: ACCOUNT_ROLE_DETAILS_ADD_LICENSE_ADD_STATE_MODAL_FULL_PATH,
            addLicensePath: ACCOUNT_ROLE_DETAILS_ADD_LICENSE_FULL_PATH,
          };

          return (
            <Switch>
              <Route path={`${routeMatch.url}/${ADD_LICENSE_PATH}`}>
                <AddLicenseFormProvider
                  qualificationId={qualificationId}
                  inReviewPath={paths.inReviewPath}
                  duplicatePath={paths.duplicatePath}
                  errorPath={paths.errorPath}
                  submittingPath={paths.submittingPath}
                >
                  <AddLicensePage
                    qualificationId={qualificationId}
                    addQualificationPath={paths.addQualificationPath}
                    addStatePath={paths.addStatePath}
                  />
                  <AddLicenseModalRoutes
                    basePath={`${routeMatch.url}/${ADD_LICENSE_PATH}`}
                    roleDetailsPath={paths.roleDetailsPath}
                    qualificationId={qualificationId}
                    addLicensePath={paths.addLicensePath}
                  />
                </AddLicenseFormProvider>
              </Route>

              <Route path={routeMatch.url}>
                <AccountRoleDetailsPage qualificationId={qualificationId} />
                <RoleModalRoutes basePath={`${routeMatch.url}`} rolesPath={paths.rolePath} />
              </Route>
            </Switch>
          );
        }}
      />
    </Switch>
  );
}
